exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link:hover{color:var(--color-anyrent);border-color:var(--color-anyrent);padding-bottom:1px}.link{text-decoration:none;border-bottom:1px solid var(--color-matterhorn)}.link:after{border-color:var(--color-anyrent);border-bottom:1px solid red}", ""]);

// exports
